module.exports = __webpack_public_path__ + "img/template_placeholder_green@2x.72e01f9.png";